import {
  DetailRequirement,
  EngagementTaskTrait,
  MultipleTaskTraitDetail,
  SingularTaskTraitDetail,
} from '@cibo/core'
import { Markdown } from '@cibo/ui'
import { Stack, TextField } from '@mui/material'
import { useDebounceCallback } from '@react-hook/debounce'
import { UseQueryResult } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useProgramEngagementContext } from '../../../../context'
import { TaskDataModel } from '../../models/TaskDataModel'

type LongTextDataEntryFieldProps = {
  taskId: string
  traitConfig: EngagementTaskTrait
  taskData: UseQueryResult<TaskDataModel, Error>
  detailRequirement?: DetailRequirement
  resourceId: string
  onChange: (detail: MultipleTaskTraitDetail | SingularTaskTraitDetail) => void
  immutable?: boolean
  traitDetailValue: any
}

export const LongTextDataEntryField = ({
  detailRequirement,
  traitConfig,
  onChange,
  immutable,
  traitDetailValue,
}: LongTextDataEntryFieldProps) => {
  const { taskData, engagement } = useProgramEngagementContext()

  const traitStatus = taskData.data?.getTraitStatus(traitConfig.traitId)
  const params = traitStatus?.params

  const helperText = params?.helperTextMd

  const [displayValue, setDisplayValue] = useState<string>()

  useEffect(() => {
    if (!displayValue) setDisplayValue(traitDetailValue)
  }, [traitDetailValue])

  const saveNewValue = useDebounceCallback((newValue: string) => {
    onChange({
      traitId: traitConfig.traitId,
      value: newValue,
      year: detailRequirement?.year,
    })
  }, 300)

  useEffect(() => {
    if (displayValue !== undefined && displayValue !== traitDetailValue) {
      saveNewValue(displayValue)
    }
  }, [displayValue])

  return (
    <Stack spacing={1}>
      <TextField
        slotProps={{ input: { inputProps: { 'data-testid': 'longText-input' } } }}
        multiline
        rows={3}
        value={displayValue}
        onChange={event => setDisplayValue(event.target.value)}
        disabled={immutable}
      />
      {!!helperText && (
        <Markdown typographyProps={{ variant: 'caption' }}>
          {engagement.data?.replaceCopyTokens(helperText)}
        </Markdown>
      )}
    </Stack>
  )
}
